import React, { Fragment, useEffect, useState } from "react";
import Avatar from "@/components/ui/avatar";
import Multiline from "@/components/ui/multiline";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader } from "@/components/ui/loader";
import NoDataView from "@/components/ui/no-data-view";
import { getUserInitials } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useGuestlist } from "@/hooks/use-event-group-participants";
import useInView from "@/hooks/use-in-view";

import SkeletonListLoader from "@/components/app/manage-event/guest-skelaton";
import { Trash } from "iconsax-react";
import { X } from "lucide-react";

interface GroupUserListProps {
  users: any;
  isLoading: boolean;
  onDeleteUser: (userId: string) => void;
  fetchNext: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  isFetching?: boolean;
  deletingUserId?: string;
}

const GroupUserList: React.FC<GroupUserListProps> = ({
  users,
  isLoading,
  isFetchingNextPage,
  onDeleteUser,
  fetchNext,
  hasNextPage,
  isFetching,
  deletingUserId = ""
}) => {
  const [allGroupsRef, allCalInView] = useInView({
    threshold: 0.01
  });
  useEffect(() => {
    if (hasNextPage && !isFetching && allCalInView && !isFetchingNextPage && !isLoading) {
      fetchNext();
    }
  }, [allCalInView, hasNextPage, isFetchingNextPage, isLoading]);

  if (isLoading) {
    return <SkeletonListLoader />;
  }

  return (
    <>
      {/* <ScrollArea className="h-[calc(100dvh-615px)] md:h-[calc(100dvh-650px)]"> */}
      {users && users?.pages[0]?.data.length > 0 ? (
        users?.pages?.map((page: any) =>
          page?.data?.map((user: any, index: number) => {
            const initals = getUserInitials(user);
            return (
              <>
                <Fragment>
                  <div key={index}>
                    <Multiline
                      key={index}
                      icon={
                        <div className="flex gap-m items-center">
                          <Avatar
                            text={initals}
                            imgSrc={user?.profile_photo}
                            size={56}
                            activeRing={true}
                            variant={user?.profile_photo ? "image" : "initials"}
                            present={false}
                            presence={false}
                          />
                        </div>
                      }
                      text1={user?.email}
                      titleTextSize={"medium"}
                      text1Size={"small"}
                      action={
                        <Button
                          variant="text"
                          disabled={deletingUserId === user.id}
                          loading={deletingUserId === user.id}
                          // onClick={() => handleDelete(user.id)}
                          onClick={() => onDeleteUser(user.id)}
                        >
                          <X size={20} />
                        </Button>
                      }
                    />
                  </div>
                  <div className="border-b border-gray-200 w-full"></div>
                </Fragment>
              </>
            );
          })
        )
      ) : (
        <div className="content-center h-full mx-auto text-center">
          <NoDataView title={`No members found.`} imageKey={"guest"} />
        </div>
      )}

      {isFetchingNextPage && (
        <div className="mx-auto mt-3">
          <Loader />
        </div>
      )}
      <div ref={allGroupsRef} className="h-5 " />
      {/* </ScrollArea> */}
    </>
  );
};

export default GroupUserList;
